import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { InventoryOutput } from "~@/graphql/codegen/generated";

interface InventoryState {
  selectedCar?: InventoryOutput;
}

const initialState: InventoryState = {
  selectedCar: undefined,
};

const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    setSelectedCar(state, action: PayloadAction<InventoryOutput | undefined>) {
      state.selectedCar = action.payload;
    },
    clearSelectedCar(state) {
      state.selectedCar = undefined;
    },
  },
});

export const { setSelectedCar, clearSelectedCar } = inventorySlice.actions;
export default inventorySlice.reducer;
